import React, { useState, useEffect } from "react";
import { useLang } from "../../i18n/LanguageContext";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";

const Testimonials = () => {
  const { t } = useLang();
  const items = t("testimonials.items");
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setIdx((i) => (i + 1) % items.length), 7000);
    return () => clearInterval(id);
  }, [items.length]);

  const cur = items[idx];

  return (
    <section className="relative py-32 lg:py-48 bg-[#050B1B]" data-testid="testimonials-section">
      <div className="container-sat">
        <div className="flex justify-between items-end mb-16 gap-8 flex-col md:flex-row">
          <div className="max-w-2xl">
            <div className="overline mb-6">{t("testimonials.overline")}</div>
            <h2 className="headline-xl text-4xl md:text-5xl lg:text-6xl">{t("testimonials.title")}</h2>
          </div>
          <div className="flex gap-2">
            <button onClick={() => setIdx((i) => (i - 1 + items.length) % items.length)} className="w-12 h-12 rounded-full glass flex items-center justify-center hover:bg-white/[0.05]" data-testid="testimonial-prev"><ChevronLeft size={18} /></button>
            <button onClick={() => setIdx((i) => (i + 1) % items.length)} className="w-12 h-12 rounded-full glass flex items-center justify-center hover:bg-white/[0.05]" data-testid="testimonial-next"><ChevronRight size={18} /></button>
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-8" data-testid="testimonial-active">
            <Quote size={48} className="text-[#D4AF37]/70 mb-6" />
            <blockquote className="serif italic text-3xl md:text-5xl font-light leading-tight text-white/90">
              „{cur.q}"
            </blockquote>
            <div className="mt-10 flex items-center gap-4">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#4B2E83] opacity-80 flex items-center justify-center serif text-lg text-[#081328]">
                {cur.a[0]}
              </div>
              <div>
                <div className="text-white">{cur.a}</div>
                <div className="text-xs uppercase tracking-widest text-white/40 mt-1">{cur.l}</div>
              </div>
            </div>
          </div>
          <div className="lg:col-span-4 space-y-2" data-testid="testimonial-list">
            {items.map((it, i) => (
              <button
                key={i}
                onClick={() => setIdx(i)}
                className={`w-full text-left p-5 rounded-xl border transition ${i === idx ? "bg-white/[0.05] border-white/15" : "bg-transparent border-white/5 hover:bg-white/[0.025]"}`}
                data-testid={`testimonial-thumb-${i}`}
              >
                <div className="text-sm text-white/75 line-clamp-2">{it.q}</div>
                <div className="text-xs uppercase tracking-widest text-white/40 mt-3">{it.a} · {it.l}</div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
